import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MessagesReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { MessagesReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class MessagesReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getMessagesReport(filter: MessagesReportFilterForm): Observable<DataWithPagination<MessagesReport[]>> {
    return this.baseAPI.post(Constants.GET_MESSAGES_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<MessagesReport[]> = {
          data: this.mapper.fromListJson(MessagesReport, res.data),
          count: res.count,
        };
        return data;
      })
    );
  }
}
